var site = site || {};
site.Utilities = (() => {
    // Functions

    // const functionName = () => {
    //
    // };

    const underlayBelow25 = () => {
        const underlayBelowEls = document.querySelectorAll('.js-underlay-below-25');

        if(underlayBelowEls){
            underlayBelowEls.forEach((el, i) => {
                const siblingHeight = el.parentElement.nextElementSibling.getBoundingClientRect().height;
    
                el.style.paddingBottom = (siblingHeight / 4 + 96) + "px";
            })
        }
    }

    const underlayBelow50 = () => {
        const underlayBelowEls = document.querySelectorAll('.js-underlay-below-50');

        if(underlayBelowEls){
            underlayBelowEls.forEach((el, i) => {
                const sectionContainer = el.classList.contains("hero-video-header") ? el.parentElement.parentElement : el.parentElement;
                const siblingHeight = sectionContainer.nextElementSibling.getBoundingClientRect().height;
    
                el.style.paddingBottom = (siblingHeight / 2 + 96) + "px";
            })
        }
    }

    const overlayAbove25 = () => {
        const overlayAboveEls = document.querySelectorAll('.js-overlay-above-25');

        if (overlayAboveEls) {
            overlayAboveEls.forEach((el, i) => {
                const elHeight = el.getBoundingClientRect().height;
    
                el.style.marginTop = "-" + (elHeight / 4) + "px";
            })
        }
    }

    const overlayAbove50 = () => {
        const overlayAboveEls = document.querySelectorAll('.js-overlay-above-50');

        if(overlayAboveEls) {
            overlayAboveEls.forEach((el, i) => {
                const elHeight = el.getBoundingClientRect().height;
    
                el.style.marginTop = "-" + (elHeight / 2) + "px";
            })
        }
    }

    const ulCheckmarkBullets = ()  => {
        const checkmarkBullets = document.querySelectorAll('.js-checkmark-bullets');

        if(checkmarkBullets.length > 0) {
            checkmarkBullets.forEach((el, i) => {
                el.parentElement.parentElement.style.listStyle = "none";
                el.parentElement.parentElement.style.paddingLeft = 0;
            })
        }
    }

    const divvyHeadlines = () => {
        const articleDetail = document.querySelector('article.js-detail-wrapper');
    
        if (articleDetail) {
            const headings = articleDetail.querySelectorAll('h1, h3, h4, h5, h6');
            const h2Elements = articleDetail.querySelectorAll('h2');

            h2Elements.forEach((h2) => {
                h2.classList.add('h4');
            })
    
            headings.forEach((heading) => {
                heading.classList.add(`${heading.tagName.toLowerCase()}-sm`);
            })
        }
    }

    const logAdClick = (type, currentUrl, contactGroup) => {
        console.log("log ad click method hit");
        fetch('/AdTracking/LogAdClick', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                type: type,
                currentUrl: currentUrl,
                contactGroup: contactGroup
            })
        }).catch(err => console.error('LogAdClick failed', err));
    };

    // Return
    return {
        // functionName : functionName
        underlayBelow25 : underlayBelow25,
        underlayBelow50 : underlayBelow50,
        overlayAbove25 : overlayAbove25,
        overlayAbove50 : overlayAbove50,
        ulCheckmarkBullets : ulCheckmarkBullets,
        divvyHeadlines: divvyHeadlines,
        logAdClick: logAdClick
    };
})();